export const growthbookFeatures = {
	WEB_DELIVERY: 'web_delivery',
	FRONTEND_CAMPAIGN_WIZARD_ADVANCE_SETTINGS:
		'frontend_campaign_wizard_advance_settings',
	AUDIENCE_TYPE_TOGGLE_1M: 'audience_type_toggle_1m',
	UNLAYER_TEMPLATE_EDITOR: 'unlayer_template_editor',
	REELS_VIDEO_REPLIES: 'reels_video_replies',
	NICHE_INBOX_VIDEO_REPLIES: 'niche_inbox_video_replies',
	CONTACTS_APPROVAL_CRM: 'crm_contacts_approval_limit',
	INBOX_MEDIA_MESSAGES: 'show_inbound_media',
	HIDE_CHATBOT_UPDATE_SUGGESTIONS: 'hide_chatbot_update_suggestions',
	MUX_PLAYER_THUMBNAIL_GIF: 'mux_player_thumbnail_gif',
	AUDIENCE_RULE_V2: 'audience_rule_v2',
	MAP_STAGES: 'map_stages',
	FRONTEND_CONTACT_EXPORT: 'frontend_contact_export',
	CO_PILOT_SPAM_CHECKER: 'co-pilot-spam-checker',
	CAMPAIGN_CAPTION_STYLING: 'campaign_caption_styling',
	CAMPAIGN_LEAD_FORMS: 'campaign_lead_forms',
	CHATBOT_LEAD_FORMS: 'chatbot_lead_forms',
	CONTACT_DETAILS_DRAWER_V2: 'contact_details_drawer_v2',
	FRONTEND_INBOX_AUDIENCE_SELECTOR_V2: 'frontend_inbox_audience_selector_v2',
	AUDIENCES_V3_SEGMENT_FOR_ALL: 'audiences_v3_segment_for_all',
	CONTACT_ATTRIBUTE_VALUES_DISTINCT: 'contact_attribute_values_distinct',
	AUDIENCE_STATS_FILTERS_RELATIVE_DATES: 'audience_stats_filters_relative_date',
	OFFER_CTA_CREATION: 'offer_cta_creation',
	V_PAGE_BUILD_THEME_SWITCH: 'v-page-build_theme-switch',
	VIEW_CONTACTS_AUDIENCES_BULK_SEGMENT: 'view_contacts_audiences_bulk_segment',
	INQUIRY_FORM_TEMPLATES: 'inquiry_form_templates',
	AUDIENCES_STATS_FILTER: 'audiences_stats_filter',
	AUDIENCES_STATS_FILTER_IN_BULK_MODAL: 'audiences_stats_filter_in_bulk_modal',
	AUDIENCES_STATS_RATE_FILTERS: 'audiences_stats_rate_filters',
	AUDIENCES_STATS_RATE_FILTERS_IN_BULK_MODAL:
		'audiences_stats_rate_filters_in_bulk_modal',
	EDIT_LIVE_CAMPAIGN_CTA: 'edit_live_campaign_cta',
	REMOVE_RECORDERS_ONE_TO_ONE_CAMPAIGNS:
		'remove-recorders-one-to-one-campaigns',
	CHATBOT_PERPLEXITY_WEBSEARCH: 'chatbot_perplexity_websearch',
	ENFORCE_SLATE_9_DIGIT_REFS: 'enforce_slate_9_digit_refs',
	ADVANCE_CAMPAIGN_USER_PERSONALIZATION:
		'advance_campaign_user_personalization',
	PAYLOAD_MAPPING_SUGGESTIONS: 'payload_mapping_suggestions',
	NICHE_AUDIENCE_SELECTION_IN_VIDEO_BUILDING:
		'niche_audiences_in_video_building',
	SHOW_MILESTONES_BREAKDOWN: 'show_milestones_breakdown',
};
